/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import api from '@utils/api'

export const validarCertificado = (token) => async (_dispatch, _getState) => {
  const response = await api.validarCertificado(token)
  return response
}
